"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeGetDeliverrError = void 0;
const ApiErrorSerializers_1 = require("@deliverr/commons-logs/lib/ApiErrorSerializers");
const commons_objects_1 = require("@deliverr/commons-objects");
const maybeGetDeliverrError = (err) => {
    var _a, _b;
    const errorSource = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error;
    const deliverrErrorCode = errorSource === null || errorSource === void 0 ? void 0 : errorSource.code;
    if (deliverrErrorCode) {
        return new commons_objects_1.DeliverrError({
            code: deliverrErrorCode,
            subcode: errorSource.subcode,
            message: errorSource.message,
            payload: errorSource.payload || (0, ApiErrorSerializers_1.apiErrorSerializer)(err.response),
        });
    }
    return undefined;
};
exports.maybeGetDeliverrError = maybeGetDeliverrError;
//# sourceMappingURL=maybeGetDeliverrError.js.map